import useFetchAdConfig from "_components/features/ads/useFetchAdConfig";

const AdConfig = () => {
	useFetchAdConfig ();

	return null;
};

export default AdConfig;
